module.exports = __webpack_public_path__ + "static/img/title-handpick.e285c5a5.png";